<template>
    <div
        v-if="todisplay"
        v-show="isvisible"
        class="flexRow"
        :class="cssclasscomputed"
    >
        <QIcon
            v-if="lefticoncomputed"
            :name="lefticoncomputed"
            :color="colorcomputed"
            class="q-mr-sm"
        />

        <div class="mslTextContext ellipsis">{{ textcomputed }}</div>

        <div class="mslRightContext">
            <div v-if="righttextcomputed" class="mslRightTextContext">
                {{ righttextcomputed }}
            </div>
            <QIcon
                v-if="righticoncomputed"
                :name="righticoncomputed"
                class="mslRightIconContext"
            />
        </div>

        <QTooltip
            v-if="tooltipcomputed"
            anchor="top middle"
            self="bottom middle"
        >
            {{ tooltipcomputed }}
        </QTooltip>
    </div>
</template>


<script>
    import utils from '@/Shared/utils.jsx';
    import BaseComponent from './BaseComponentMixin.jsx';
    import { QIcon, QTooltip } from 'quasar';
    

    export default {
        name: "MultiSelectListItem",
        mixins: [BaseComponent],
        components: {
            QIcon,
            QTooltip,
        },
        props: ['sourceData','template'],
        data() {
            return {
                righticon: null,
                lefticon: null,
                text: null,
                tooltip: null,
                typex: null,
                value: null,
                color: null,
                cssclass: null,
                righttext: null,
                hovercolor: null,
            };
           
        },
        created() {
          
        },
        computed: {
            styles: function () {
                return {
                    ...utils.resolveStyleHints(this.styleHints, this),
                    ...this.sizeStyle,
                    display: 'flex',
                    flexDirection: 'column'
                }
            },
          
            // NEED TO COMPILE/EVAL THE ITEM ATTRIBUTES

            righticoncomputed() {
                try {
                    if (this.righticon === null && this.template?.RightIcon !== null)
                        this.righticon = utils.compile(this, this.template.RightIcon);

                    let righticon = utils.evaluate(this.righticon, this);
                    return this.normalizeIconName(righticon);
                } catch (e) {
                    utils.warn("Right Icon could not evaluate expression: " + this.template.RightIcon + "; " + e);
                    return "";
                }
            },
            lefticoncomputed() {
                try {
                    if (this.lefticon === null && this.template?.LeftIcon !== null)
                        this.lefticon = utils.compile(this, this.template.LeftIcon);

                    let lefticon = utils.evaluate(this.lefticon, this);
                    return this.normalizeIconName(lefticon);
                } catch (e) {
                    utils.warn("Left Icon could not evaluate expression: " + this.template.LeftIcon + "; " + e);
                    return "";
                }
            },
            //Text
            textcomputed() {
                try {
                    if (this.text === null && this.template?.Text !== null)
                        this.text = utils.compile(this, this.template.Text);

                    let text = utils.evaluate(this.text, this);

                    
                    return text;
                } catch (e) {
                    utils.warn("Text could not evaluate expression: " + this.template.Text + "; " + e);
                    return "";
                }
            },
            // Tooltip
            tooltipcomputed() {
                try {
                    if (this.tooltip === null && this.template?.Tooltip !== null)
                        this.tooltip = utils.compile(this, this.template.Tooltip);

                    let tooltip = utils.evaluate(this.tooltip, this);

                    return tooltip;
                } catch (e) {
                    utils.warn("Tooltip could not evaluate expression: " + this.template.Tooltip + "; " + e);
                    return "";
                }
            },
            //Type
            typecomputed() {
                try {
                    if (this.typex === null && this.template?.Type !== null)
                        this.typex = utils.compile(this, this.template.Type);

                    let typex = utils.evaluate(this.typex, this);
                                        
                    return typex;
                } catch (e) {
                    utils.warn("Type could not evaluate expression: " + this.template.Type + "; " + e);
                    return "";
                }
            },
            //Value
            valuecomputed() {
                try {
                    if (this.value === null && this.template?.Value !== null)
                        this.value = utils.compile(this, this.template.Value);

                    let value = utils.evaluate(this.value, this);

                    return value;
                } catch (e) {
                    utils.warn("Value could not evaluate expression: " + this.template.Value + "; " + e);
                    return "";
                }
            },
            //Color
            colorcomputed() {
                try {
                    if (this.color === null && this.template?.Color !== null)
                        this.color = utils.compile(this, this.template.Color);

                    let color = utils.evaluate(this.color, this);

                    return color;

                } catch (e) {
                    utils.warn("Color could not evaluate expression: " + this.template.Color + "; " + e);
                    return "";
                }
            },
            //CssClass
            cssclasscomputed() {
                try {
                    if (this.cssclass === null && this.template?.CssClass !== null)
                        this.cssclass = utils.compile(this, this.template.CssClass);

                    let cssclass = utils.evaluate(this.cssclass, this);
                    return cssclass;
                } catch (e) {
                    utils.warn("CssClass could not evaluate expression: " + this.template.CssClass + "; " + e);
                    return "";
                }
            },
            //RightText
            righttextcomputed() {
                try {
                    if (this.righttext === null && this.template?.RightText !== null)
                        this.righttext = utils.compile(this, this.template.RightText);

                    let righttext = utils.evaluate(this.righttext, this);

                    return righttext;
                } catch (e) {
                    utils.warn("RightText could not evaluate expression: " + this.template.RightText + "; " + e);
                    return "";
                }
            },

            //HoverColor
            hovercolorcomputed() {
                try {
                    if (this.hovercolor === null && this.template?.HoverColor !== null)
                        this.hovercolor = utils.compile(this, this.template.HoverColor);

                    let hovercolor = utils.evaluate(this.hovercolor, this);

                    return hovercolor;
                } catch (e) {
                    utils.warn("Left Icon could not evaluate expression: " + this.template.HoverColor + "; " + e);
                    return "";
                }
            },

            
        },
       
        methods: {
            normalizeIconName(iconName) {
                if (!iconName || typeof iconName !== 'string')
                    return iconName;

                if (iconName.startsWith('mdi '))
                    return iconName.substr(4);

                // Keep explicit icon-set syntaxes as-is (e.g. "mdi-...", "img:...", "fa ...", "mat:...")
                if (iconName.startsWith('mdi-') || iconName.includes(':') || iconName.includes(' '))
                    return iconName;

                // Legacy templates often store mdi names without the prefix, e.g. "clock-outline".
                if (iconName.includes('-'))
                    return `mdi-${iconName}`;

                return iconName;
            },

        },
    }

</script>

<style scoped>
    .flexRow {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        align-items: center;
    }

    .mslTextContext {
        flex: 1 1 auto;
        min-width: 0;
    }

    .mslRightTextContext {
        flex: 0 0 auto;
    }

    .mslRightContext {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 0 0 auto;
    }

    .mslRightIconContext {
        flex: 0 0 auto;
    }
</style>
